import { render, staticRenderFns } from "./SeoCreate.vue?vue&type=template&id=4b5cc797&scoped=true"
import script from "./SeoCreate.vue?vue&type=script&lang=js"
export * from "./SeoCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5cc797",
  null
  
)

export default component.exports